import AdminQuotationsPage from './AdminQuotationsPage'

export default function AdminQuotationsRoute() {
  return <AdminQuotationsPage />
}
